export default __webpack_public_path__ + "static/media/Honored Harness of the Everlasting Sky.1c1406f1.jpg";